import { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import Navigation from './Navigation';
import Footer from './Footer';
import TrialBanner from './TrialBanner';
import KeyboardShortcutsModal from '../Common/KeyboardShortcutsModal';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';
import { useEmbed } from '../../hooks/useEmbed';
import '../../styles/embed-cockpit.css';

function Layout({ children }) {
  const { isEmbed } = useEmbed();

  const location = useLocation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  const [showShortcutsModal, setShowShortcutsModal] = useState(false);
  const prevPathRef = useRef(location.pathname);

  // Globale Keyboard Shortcuts
  const shortcuts = {
    '?': useCallback(() => setShowShortcutsModal(true), []),
    'escape': useCallback(() => setShowShortcutsModal(false), []),
    'k': useCallback(() => {
      // Neuer Kunde - zur Kundenseite mit Modal-Trigger
      if (!location.pathname.startsWith('/kunden')) {
        navigate('/kunden?neu=true');
      }
    }, [navigate, location.pathname]),
  };

  useKeyboardShortcuts(shortcuts, !showShortcutsModal);

  useEffect(() => {
    // Nur bei echtem Route-Wechsel animieren
    if (prevPathRef.current !== location.pathname) {
      setIsVisible(false);
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 50);
      prevPathRef.current = location.pathname;
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // Embed-Mode: Nur Content ohne Header/Navigation/Footer (HeyKiki iFrame
  // ODER Cockpit-Preview Demo-Overlay). Die `embed-cockpit-root`-Klasse
  // aktiviert die Flugzeugcockpit-Optik aus `styles/embed-cockpit.css`.
  if (isEmbed) {
    return (
      <div className="min-h-screen bg-background embed-cockpit-root">
        <main>{children}</main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <TrialBanner />
      <Header />
      <Navigation />
      <main
        className={`flex-1 transition-opacity duration-150 ease-out ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        {children}
      </main>
      <Footer />

      {/* Keyboard Shortcuts Help Modal */}
      <KeyboardShortcutsModal
        isOpen={showShortcutsModal}
        onClose={() => setShowShortcutsModal(false)}
      />
    </div>
  );
}

export default Layout;
